import React from "react";
import { Form, Row, Col } from "antd";
import ControlledTextArea from "../../components/ControlledTextArea";
import ControlledRadio from "../../components/Backoffice/ControlledRadio";

const RequestCorrectionForm = ({ control, watch, errors, setValue }) => {
  return (
    <Form colon={false}>
      
      <Row gutter={24}>
        <Col span={24}>
          <ControlledTextArea
            required
            control={control}
            name="detailedInstructions"
            label="Detailed Correction"
            errors={errors}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default RequestCorrectionForm;
